interface MSNavigator extends Navigator {
  msSaveBlob?: (blob: Blob, defaultName?: string) => boolean;
}

export function downloadFile(blob: Blob, filename: string) {
  const msNavigator = window.navigator as MSNavigator;
  if (typeof msNavigator.msSaveBlob !== "undefined") {
    msNavigator.msSaveBlob(blob, filename);
    return;
  }
  const blobURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.href = blobURL;
  tempLink.setAttribute("download", filename);
  if (typeof tempLink.download === "undefined") {
    tempLink.setAttribute("target", "_blank");
  }
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  setTimeout(() => {
    window.URL.revokeObjectURL(blobURL);
  }, 100);
}
